import { Component } from '@angular/core';

@Component({
  selector: 'span[app-button-toggle-content]',
  standalone: true,
  template: '<ng-content></ng-content>',
  styleUrls: ['button-toggle-content.component.scss']
})
export class ButtonToggleContentComponent {}
